import { warn } from './notify';
import { deleteUser, editUser } from './request/admin';
import { logout, nibioToken } from './request/authentication';

const remove = document.getElementById('deleteUserBtn');
const list = document.getElementById('listOfUsers');
const fMail = document.getElementById('fMail');
const fName = document.getElementById('fName');
const fExpiration = document.getElementById('fExpiration');
const fComment = document.getElementById('fComment');
const rights = document.getElementById('rights');
const today = new Date();
const in2years = new Date();
in2years.setFullYear(in2years.getFullYear() + 2);
const iso = new Date(in2years).toISOString().substring(0, 10); // yyyy-mm-dd

export const getUser = () => nibioToken.user;

export const updateUserInfo = () => {
  const userId = fMail.dataset.userId;
  const li = document.getElementById('li' + userId);
  const newExpiration = fExpiration.value || fExpiration.defaultValue;
  const newComment = fComment.value;
  const locale = new Date(newExpiration).toLocaleDateString('nb-NO');
  editUser(userId, newExpiration, newComment).then(() => {
    if (li) {
      li.className = new Date(newExpiration) > today ? 'active' : 'expired'
      li.title = `${newComment} [${locale}]`;
      li.dataset.expiration = newExpiration;
      li.dataset.comment = newComment;
    }
    fMail.disabled = false;
    fMail.value = '';
    fExpiration.value = iso;
    fComment.value = '';
  });
};

export const itemFromUser = (user) => {
  const li = document.createElement('li');
  li.id = 'li' + user.id;
  li.innerHTML = user.email;
  const validTil = user.validTil || '2080-12-31';
  const expiration = new Date(validTil);
  const exp = expiration.toLocaleDateString('nb-NO');
  li.title = `${user.comment || 'Frist'} [${exp}]`;
  li.className = expiration > today ? 'active' : 'expired';
  li.dataset.expiration = validTil.substring(0, 10);
  li.dataset.comment = user.comment;
  const editBtn = document.createElement('button');
  editBtn.type = 'button'; // prevents triggering form submit
  editBtn.className = 'x-btn green-transition';
  editBtn.setAttribute('ariaLabel', 'Redigere');
  editBtn.title = 'Rediger bruker';
  editBtn.innerHTML = '<span aria-hidden="true">&#x1F589;</span>';
  // editBtn.innerHTML = '<span aria-hidden="true">&#x270e;</span>';
  editBtn.onmouseenter = () => {
    if (fMail.disabled) return;
    fMail.dataset.userId = user.id;
    fMail.dataset.original = fMail.value;
    fMail.value = user.email;
    fExpiration.dataset.original = fExpiration.value;
    fExpiration.value = li.dataset.expiration;
    fComment.dataset.original = fComment.value;
    fComment.value = li.dataset.comment;
  };
  editBtn.onmouseleave = () => {
    if (fMail.disabled) return;
    fMail.value = fMail.dataset.original;
    fExpiration.value = fExpiration.dataset.original;
    fComment.value = fComment.dataset.original;
  };
  // editBtn.onclick = updateUserInfo;
  editBtn.onclick = () => fMail.disabled = true;
  li.appendChild(editBtn);
  const deleteBtn = document.createElement('button');
  deleteBtn.type = 'button'; // prevents triggering form submit
  deleteBtn.className = 'x-btn red-transition';
  deleteBtn.setAttribute('ariaLabel', 'Fjern');
  deleteBtn.title = 'Fjern brukerrettigheter';
  deleteBtn.innerHTML = '<span aria-hidden="true">&times;</span>';
  deleteBtn.innerHTML = '<span aria-hidden="true">&#x1F5D1;</span>';
  deleteBtn.onclick = () => {
    deleteUser(user.id).then(() => list.removeChild(li));
  };
  li.appendChild(deleteBtn);
  return li;
};

export const listUsers = (users) => {
  list.innerHTML = '';
  // console.log('Listing', users.length, 'users');
  users.forEach(u => list.appendChild(itemFromUser(u)));
};

export const fillProfileIn = (user) => {
  fMail.value = user.email || '';
  fName.value = user.name || '';
  if (user.validMunicipalities) user.validMunicipalities.forEach(m => {
    const li = document.createElement('li');
    li.innerHTML = m;
    rights.appendChild(li);
  });
  // else rights.remove(); // I need rights after activation, do not remove it
  remove.onclick = () => deleteUser(user.id, 'itself').then(() => {
    logout(true);
    document.getElementById('backHomeFromUserBtn').click();
  }).catch(m => warn(m));
};

